import styled from 'styled-components';
import { theme } from '../../../config';

export const Container = styled.div`
  align-items: center;
  flex: 1;
  justify-content: center;
  height: 450px;
`;

export const ContentWrapper = styled.div`
  text-align: center;
  margin: 130px auto;
  @media ${theme.breakpoints.mobile} {
    width: 75vw;
  }
`;

export const ErrorMessage = styled.p`
  margin: auto 5px;
  font-weight: bold;
  font-size: 2rem;
  font-family: ${theme.fonts.default};
  line-height: 3rem;
  font-style: normal;
  @media ${theme.breakpoints.mobile} {
    font-size: 1.5rem;
    line-height: 2.2rem;
  }
`;

export const ButtonWrapper = styled.div`
  width: 300px;
  height: 52px;
  border-radius: 5px;
  margin: 70px auto;
  @media ${theme.breakpoints.mobile} {
    margin: 70px auto;
    max-width: 250px;
    height: 42px;
    > button {
      font-size: 0.8125rem;
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
`;
